export const environment = {
  production: false,
  testMode: true,
  authServiceUrl: 'https://legitimera-test.internal.sparbankensyd.se/service',
  bilAPIUrl: 'https://legitimera-test.internal.sparbankensyd.se/bil',
  domain: 'legitimera-stage.internal.sparbankensyd.se',
  adminLink: 'https://legitimera-admin-test.internal.sparbankensyd.se/'
}
